/** @file clipEnded: whether a one-shot clip has reached its held last frame (loops never end). */
import type { Clip } from '@zilo/pose3d-format/types/clip';
import { clipFrame } from '@zilo/pose3d-pose/time/clipFrame';

/** True when `clip` does not loop and one more frame of time no longer advances pose's `clipFrame`. */
export function clipEnded(clip: Clip, time: number): boolean {
  if (clip.loop && clip.frames - clip.loopStart > 0) return false;
  const at = (t: number): number => clipFrame(clip, t, { frame: 0, wraps: 0, elapsed: 0, ticks: 0 }).frame;
  return at(time) === at(time + 1 / clip.fps);
}
